module.exports = __webpack_public_path__ + "static/media/heros_cn.848b127f.png";